import { NavLink, useLocation } from "react-router-dom";
import { Sparkles, LayoutGrid, Images, Users, MessageSquare, Settings as SettingsIcon, ShieldCheck, ShoppingBag } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const PUBLIC = ["/login", "/signup", "/invite", "/forgot-password", "/reset-password", "/demo", "/", "/art"];

export const MobileNav = () => {
  const { status, user } = useAuth();
  const location = useLocation();
  const onPublic = PUBLIC.some((r) => (r === "/" ? location.pathname === "/" : location.pathname.startsWith(r)));
  if (status !== "authed" || !user || onPublic) return null;
  // Sales reps use the top Studio/History tabs in the header — no bottom nav.
  if (user.role === "sales_rep") return null;

  const isEditor = ["owner", "manager"].includes(user.role);
  const items = [{ to: "/studio", icon: Sparkles, label: "Studio" }];
  if (isEditor) items.push({ to: "/library", icon: LayoutGrid, label: "Library" });
  items.push({ to: "/history", icon: Images, label: "History" });
  items.push({ to: "/store", icon: ShoppingBag, label: "Store" });
  if (isEditor) items.push({ to: "/team", icon: Users, label: "Team" });
  if (user.is_superadmin) items.push({ to: "/console", icon: ShieldCheck, label: "Admin" });
  else items.push({ to: "/messages", icon: MessageSquare, label: "Inbox" });
  items.push({ to: "/settings", icon: SettingsIcon, label: "Settings" });
  const nav = items.slice(0, 5);

  return (
    <nav data-testid="mobile-nav"
      className="fixed inset-x-0 bottom-0 z-40 flex justify-center px-4 md:hidden"
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 14px)" }}>
      <div className="pointer-events-auto flex items-center gap-1 rounded-[26px] border border-black/5 bg-white/80 px-2 py-1.5 shadow-[0_12px_40px_rgba(0,0,0,0.18)] backdrop-blur-2xl">
        {nav.map(({ to, icon: Icon, label }) => (
          <NavLink key={to} to={to} data-testid={`mnav-${label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 rounded-[20px] px-3.5 py-2 text-[10px] font-semibold transition-all duration-200 ${isActive ? "bg-[var(--brand)] text-white shadow-sm" : "text-[var(--ink-soft)] active:scale-95"}`}>
            {({ isActive }) => (
              <>
                <Icon className="h-5 w-5" strokeWidth={isActive ? 2.25 : 1.75} />
                {label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
